import { useEffect } from 'react'
import { useSettings } from '../../hooks/queries'
import type { TourOptions } from '../../lib/tourOptions'
import { useTexte } from '../../texte'
import { preloadTerrain } from './terrainPreload'

/**
 * The switches of the day film (#139): following, tilted, profile, the map
 * and, since 1.129.0, the relief (#140). Since 1.125.0 there is no choice "Einfach / Komplex" any more
 * (from use: "Codebasis ‚einfach' und ‚komplex' zusammenlegen"): all off is
 * the film as it always was, and the switches stand whenever the film is on.
 * The map choice stands only where the installation does not pin the tiles
 * (`map_fixed`) -- a choice that changes nothing is a broken control. For
 * the same reason it goes while the relief is on: the relief brings its own
 * map (`lib/terrainSource.ts`).
 */
export function TourFields({ options, onChange }: { options: TourOptions; onChange: (part: Partial<TourOptions>) => void }) {
  const t = useTexte().chat.tour
  const settings = useSettings().data
  const choices = settings?.map_fixed === true ? [] : (settings?.map_choices ?? []).filter((c) => c.map !== undefined)
  // The module as soon as the switch is on (1.130.0), ticked or brought back
  // by "Neu erstellen": our own server, so nothing goes out before the build.
  useEffect(() => {
    if (options.terrain) preloadTerrain()
  }, [options.terrain])
  return (
    <div className="tour-fields" data-tour-fields="">
      <div className="tour-fields__complex" data-tour-complex="">
        <label className="kartenregler__nadel">
          <input type="checkbox" checked={options.follow} onChange={(e) => onChange({ follow: e.target.checked })} data-tour="follow" />
          <span>{t.follow}</span>
        </label>
        <label className="kartenregler__nadel">
          <input type="checkbox" checked={options.tilt} onChange={(e) => onChange({ tilt: e.target.checked })} data-tour="tilt" />
          <span>{t.tilt}</span>
        </label>
        <label className="kartenregler__nadel">
          <input type="checkbox" checked={options.profile} onChange={(e) => onChange({ profile: e.target.checked })} data-tour="profile" />
          <span>{t.profile}</span>
        </label>
        <label className="kartenregler__nadel">
          <input type="checkbox" checked={options.terrain} onChange={(e) => onChange({ terrain: e.target.checked })} data-tour="terrain" />
          <span>{t.terrain}</span>
        </label>
        {options.terrain && <p className="leise" data-tour-terrain-hint="">{t.terrainHint}</p>}
        {choices.length > 0 && !options.terrain && (
          <label className="kartenregler__nadel">
            <span>{t.map}</span>
            <select
              className="field__input"
              value={choices.some((c) => c.key === options.map) ? options.map : 'trip'}
              onChange={(e) => onChange({ map: e.target.value })}
              data-tour="map"
            >
              <option value="trip">{t.mapTrip}</option>
              {choices.map((c) => (
                <option key={c.key} value={c.key}>{c.name}</option>
              ))}
            </select>
          </label>
        )}
      </div>
    </div>
  )
}
